import React from 'react';
import { Workflow, Inbox, Filter, HeartHandshake, CheckCircle2, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function CRMCard() {
  const {
    t
  } = useLanguage();
  const stages = [{
    icon: Inbox,
    label: t.crm_stage1,
    color: 'border-white/20'
  }, {
    icon: Filter,
    label: t.crm_stage2,
    color: 'border-cyan-400/30'
  }, {
    icon: HeartHandshake,
    label: t.crm_stage3,
    color: 'border-yellow-400/30'
  }, {
    icon: CheckCircle2,
    label: t.crm_stage4,
    color: 'border-green-400/40'
  }];
  const included = [t.crm_included1, t.crm_included2, t.crm_included3, t.crm_included4, t.crm_included5, t.crm_included6];
  return <div className="bg-kinetic-card border border-white/[0.08] rounded-xl p-5 sm:p-8 hover:border-purple-500/40 transition-colors duration-300 overflow-hidden" data-id="element-36" data-mp="3ovg4oi4mybkw">
      <Workflow className="w-8 h-8 sm:w-10 sm:h-10 text-purple-400" data-id="element-37" data-mp="1ziuwc4u18nal" />
      <span className="block text-xs text-purple-400 uppercase tracking-wide mt-5 sm:mt-6" data-id="element-38" data-mp="1ujhx0klz5nr4">
        {t.crm_tag}
      </span>
      <h3 className="text-xl sm:text-2xl font-bold text-white mt-2" data-id="element-39" data-mp="nkkq0k5d61js">{t.crm_title}</h3>
      <p className="text-white/60 text-sm mt-3 leading-relaxed" data-id="element-40" data-mp="sm1lg052wvsz">{t.crm_description}</p>

      {/* Visual pipeline */}
      <div className="flex items-center gap-0.5 sm:gap-1 mt-5 sm:mt-6" data-id="element-41" data-mp="xj0dmd56msoj">
        {stages.map((stage, index) => <React.Fragment key={stage.label} data-id="element-42" data-mp="16df4lcz2rrnh" data-mpi={index}>
            <div className={`flex-1 min-w-0 text-center bg-black/40 rounded-lg p-2 sm:p-3 border ${stage.color}`} data-id="element-43" data-mp="16cdgo7wynaoc">
              <stage.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/60 mx-auto mb-1" data-id="element-44" data-mp="1baf04tyatc0c" />
              <span className="text-[9px] sm:text-xs text-white/50 uppercase block leading-tight" data-id="element-45" data-mp="1gbw1eqkp30hg">
                {stage.label}
              </span>
            </div>
            {index < stages.length - 1 && <span className="text-cyan-400/40 text-sm sm:text-xl shrink-0" data-id="element-46" data-mp="3i4sjgxd0v3b2">→</span>}
          </React.Fragment>)}
      </div>

      <div className="bg-red-950/20 border border-red-500/15 rounded-lg p-3 sm:p-4 mt-5 sm:mt-6" data-id="element-47" data-mp="3f0l41no1a9ri">
        <span className="text-xs text-red-400/70 uppercase tracking-wide block" data-id="element-48" data-mp="3a2jmj769aii5">
          {t.crm_problem_label}
        </span>
        <p className="text-white/60 text-sm mt-2" data-id="element-49" data-mp="3p028k1rjuhlw">{t.crm_problem_text}</p>
      </div>

      <div className="bg-green-950/20 border border-green-500/15 rounded-lg p-3 sm:p-4 mt-4" data-id="element-50" data-mp="3jz61jfbwifc9">
        <span className="text-xs text-green-400/70 uppercase tracking-wide block" data-id="element-51" data-mp="1tja81p94ss0">
          {t.crm_solution_label}
        </span>
        <p className="text-white/60 text-sm mt-2" data-id="element-52" data-mp="3t0m26vcwz33a">{t.crm_solution_text}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-5 sm:mt-6" data-id="element-53" data-mp="bjuqmnq4gufs">
        {included.map(item => <div key={item} className="flex items-start gap-2" data-id="element-54" data-mp="6m2yptph98bl">
            <Check className="w-3.5 h-3.5 text-cyan-400 shrink-0 mt-0.5" data-id="element-55" data-mp="kkap1is0dbds" />
            <span className="text-xs text-white/50" data-id="element-56" data-mp="gjqxcuq7ezz1">{item}</span>
          </div>)}
      </div>

      <div className="bg-white/5 rounded-lg p-3 sm:p-4 mt-5 sm:mt-6" data-id="element-57" data-mp="z813i06ecv76">
        <p className="text-white/70 text-sm" data-id="element-58" data-mp="z5optz7o96zx">{t.crm_promise}</p>
      </div>

      <a href="#consulta" className="inline-block text-purple-400 text-sm mt-5 sm:mt-6 hover:text-purple-300 transition-colors" data-id="element-59" data-mp="146cdqc0lt7px">
        {t.crm_cta}
      </a>
    </div>;
}